const styles = {
  root: {
    padding: 1,
    mt: 2,
    borderRadius: 0.5,
    '&.backgroundGray': {
      backgroundColor: '#F2F2F2',
    },
  },
}

export default styles
